import AppSettings from "../../AppSettings"

export const imageCategories = {
  SPIN: "360",
  SPIN_HERO: "360-hero",
  SUPPLEMENTAL: "2D/",
  GLASTENDER: "GT",
}

const parseFolderName = (resourcePath) => {
  if(!resourcePath)
    return null

  const prefixes = ["360-hero/", "360/", "2D/"]
  const prefix = prefixes.find((value) => resourcePath.startsWith(value))
  if(!prefix)
    return null

  const underscoreIndex = resourcePath.indexOf("_")
  if(underscoreIndex === -1)
    return null

  return resourcePath.substring(prefix.length, underscoreIndex) || null
}

export const MapSrc = (resourcePath) => {
  if(!resourcePath)
    return ""

  const resolvedFolderName = parseFolderName(resourcePath) || ""

  if(resourcePath.startsWith(imageCategories.SPIN_HERO))
    return resourcePath.replace("360-hero/", AppSettings.SpinStill(resolvedFolderName))
  
  if(resourcePath.startsWith(imageCategories.SPIN))
    return resourcePath.replace("360/", AppSettings.SpinStill(resolvedFolderName))

  if(resourcePath.startsWith(imageCategories.SUPPLEMENTAL))
    return resourcePath.replace("2D/", AppSettings.Supplemental(resolvedFolderName))

  return AppSettings.PartImage(resourcePath)
}

export const isSpin = (resourcePath) => {
  return resourcePath && resourcePath.startsWith(imageCategories.SPIN)
}

export const isSpinHero = (resourcePath) => {
  return resourcePath && resourcePath.startsWith(imageCategories.SPIN_HERO)
}

export const isSupplemental = (resourcePath) => {
  return resourcePath && resourcePath.startsWith(imageCategories.SUPPLEMENTAL)
}

